import { onMounted as s, watch as l, onUnmounted as m, provide as i, inject as v } from "vue";
let d = Symbol("StackContext");
var f = ((t) => (t[t.Add = 0] = "Add", t[t.Remove = 1] = "Remove", t))(f || {});
function p() {
  return v(d, () => {
  });
}
function k({ type: t, enabled: a, element: o, onUpdate: u }) {
  let c = p();
  function e(...n) {
    u?.(...n), c(...n);
  }
  s(() => {
    l(a, (n, r) => {
      n ? e(0, t, o) : r === !0 && e(1, t, o);
    }, { immediate: !0, flush: "sync" });
  }), m(() => {
    a.value && e(1, t, o);
  }), i(d, e);
}
export {
  f as StackMessage,
  p as useStackContext,
  k as useStackProvider
};
